import { RequestInterceptor } from "@rails/request.js";

RequestInterceptor.register(async (request) => {
  request.addHeader("X-Clio-Ui-Component", "true");
});
